import { useTranslation } from "next-i18next";
import { Control, FieldErrorsImpl } from "react-hook-form";
import PhoneInput from "react-phone-number-input/react-hook-form-input";

import { InputError, InputLabel, Text } from "@/components/elements";
import { UserFormFields } from "@/types/types";

import styles from "./styles.module.css";

type InputMobileProps = {
  control: Control<UserFormFields>;
  errors?: FieldErrorsImpl;
};

export const InputMobile = ({ control, errors }: InputMobileProps) => {
  const name = "mobile";
  const { t } = useTranslation("access");
  return (
    <div className={styles.container}>
      <InputLabel id={"mobile-field"}>{t("sms.label")}</InputLabel>
      <div className={styles.wrapper}>
        <PhoneInput
          className={styles.input}
          id={"mobile-field"}
          control={control}
          name={name}
          international
          withCountryCallingCode
          country="NO"
          placeholder={t("sms.placeholder")}
        />
      </div>
      <Text size="xxs" className={styles.hint}>
        {t("sms.hint")}
      </Text>
      {errors && <InputError errors={errors} inputName={name} />}
    </div>
  );
};
